import { createApp } from "./app.js";
import { mountUpdatePrompt } from "./ui/components/updatePrompt.js";

export function boot(registerSW, root = document.getElementById("app")) {
  const paws = createApp(root);
  const prompt = mountUpdatePrompt(registerSW, paws.app);
  const started = paws.start().catch((error) => paws.app.reporter.report(error, "start"));
  return { ...paws, prompt, started };
}
